import React from 'react';

import { SidebarAddPostTip } from './SidebarAddPostTip';

/**
 * Совет для создания поста блога в сайдбаре
 */
export const SidebarAddBlogPostTip = () => {
  return (
    <SidebarAddPostTip
      title="Подберём риелтора"
      text={
        'Надежный специалист возьмет на себя решение юридических вопросов и поможет выгодно продать сложные объекты'
      }
      theme={'gray'}
    />
  );
};
